import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WorkingHoursFacade } from './working-hours.facade';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursCreationGuard {
  constructor(private workingHoursFacade: WorkingHoursFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.workingHoursFacade.itemSetInitialState();

    return of(true);
  }
}
